import React from 'react'
import SearchPicker from '../common/SearchPicker'

const OperationPicker = (props) => {

    const { state } = props

    const option = (o) => <span>{`${o.code}, ${o.name}`}</span>

    return (
        <SearchPicker
            {...props}
            value={state ? `${state?.code}, ${state?.name}` : ""}
            option={(o) => option(o)}
        />
    )
}

export default OperationPicker